import { render } from "./_default.vue?vue&type=template&id=4995dab8"
import script from "./_default.vue?vue&type=script&lang=js"
export * from "./_default.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__